<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
                <div class="header-body">
                <div class="row align-items-center py-4">
                    <div class="col-lg-4 col-4">
                    <h2>Create Offering</h2>
                    </div>
                    <div class="col-lg-8 col-8 text-right">
                        <form @submit.prevent="" class="d-inline-block justify-content-center headSearch mr-2">
                        <i @click="searchCusip()"  class="fas fa-search active cursor-pointer" aria-hidden="true"></i>
                        <input v-on:keyup.enter="searchCusip" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm" type="text" placeholder="Search cusip" aria-label="Search">
                        <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
                        </form>
                    </div>
                </div>
                <!-- Card stats -->
                </div>
            </div>
        </div>
        <div class="container-fluid mt--6">
            <div class="row xsOnly">
                <div class="col-xl-12">
                <div class="card scrollbar vh-75" id="scroll">
                    <div class="table-responsive">
                    <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                    <table class="table align-items-center table-flush table-hover bidtbl c-offer">
                        <thead class="thead-light psticky">
                        <tr >
                            <th 
                            scope="col" 
                            class="sort"
                            v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cusip'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'cusip'  ? 'sort-desc' : '']"  
                            @click="sort('cusip')">CUSIP/DESC</th>
                            <th 
                            scope="col" 
                            class="sort text-center"
                            v-bind:class="[sortOrder == 'ASC' && sortColumn == 'maturityDate'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'maturityDate'  ? 'sort-desc' : '']"  
                            @click="sort('maturityDate')">MATURITY DATE/<br>CALL DATE</th>
                            <th 
                            scope="col" 
                            class="sort"
                            v-bind:class="[sortOrder == 'ASC' && sortColumn == 'state'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'state'  ? 'sort-desc' : '']"  
                            @click="sort('state')">STATE/<br>INSURER</th>
                            <th 
                            scope="col" 
                            class="sort"
                            v-bind:class="[sortOrder == 'ASC' && sortColumn == 'coupon'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'coupon'  ? 'sort-desc' : '']"  
                            @click="sort('coupon')">COUPON</th>
                            <th scope="col" class="text-center">Action</th>
                        </tr>
                        </thead>
                        <tbody class="list">
                        <tr v-if="totalRows == 0 && !loading">
                            <td><p class="nodata">No data available</p>
                            </td>
                        </tr>
                        <tr v-for="cusip in cusips" :key="cusip.id" @click="getCusipDetails(cusip)" v-bind:class="{'active-row': cusip.isActive}">
                            <td>
                            <span class="cusips">{{cusip.cusip}}</span>
                            <span class="desc">{{cusip.description}}</span>
                            </td>
                            <td class="text-center">
                            <span class="maturity">{{cusip.maturityDate ? moment(cusip.maturityDate).format("MM/DD/YYYY") : "N/A"}}</span><br>
                            {{cusip.callDate ? moment(cusip.callDate).format("MM/DD/YYYY") : "N/A"}}
                            
                            </td>
                            <td>
                            <span class="state d-inline">{{getStateName(cusip.stateId)}}</span>
                            <span class="insurer">{{cusip.bondInsurer}}</span>
                            </td>
                            <td>
                            <span class="coupon">{{cusip.coupon | percent(3)}}</span>
                            </td>
                            <td class="text-center">
                            <div class="d-inline-flex">
                                <a  @click="openAddNewOfferModal(cusip)" title="create offer" class="ibtn grn"><i class="fas fa-plus"></i></a>
                            </div>
                            </td>
                            </tr>
                        </tbody>
                    </table>
                    <!-- Pagination-->
                    <b-pagination
                        class="mt-4"
                        :total-rows="totalRows"
                        v-model="currentPage"
                        :per-page="perPage"
                        @input="getCusipList(currentPage)"
                    ></b-pagination>
                    <div class="total-records">
                        <span>Total Records : {{totalRows}}</span>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </div>  
        <add-offer
            v-bind:offerCusip="offerCusip" 
            v-bind:mode="'ADD'"  
            v-if="addNewOfferModalOpen" 
            @close="addNewOfferModalOpen = false">
        </add-offer>
    </div> 
      
</template>
<script>
import config from "@/config";
import authService from "@/authService";
import stateConstants from "@/stateConstants";
import addOffer from "./ImsAddOfferModal"
export default {
  name: "imsCreateOfferComponent",
  components : {
     addOffer
  },
  data() {
    return {
        accessToken: null,
        cusips: [],
        config: config,
        loading : false,
        currentPage: 1,
        perPage: 10,
        searchValue : "",
        totalRows : 0,
        sortColumn: "cusip",
        sortOrder: "ASC",
        addNewOfferModalOpen : false,
        stateConstants: stateConstants,
        offerCusip : null

    };
  },
  methods: {
    searchCusip(){
      this.getCusipList(); 
    },
    clearSearch(){
      this.searchValue = "";
      this.getCusipList(); 
    },
    sort(column){
      this.sortColumn = column;
      this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
      this.getCusipList();
    },
    getStateName(id){
      return id ? this.stateConstants.find(x => x.id === id).short : 'N/A';
    },
    getCusipDetails(cusipSelected){
      this.cusips.forEach(function(cusip) {
        cusip.isActive = false;
      });
      cusipSelected.isActive = true;
    },
    getCusipList(currentPage) {
      this.loading = true;
      if (!currentPage) {
        currentPage = 1;
      }
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
          config.baseUrlBidSide +
            "/cusip/list?page=" +
            currentPage +
            "&size=" +
            this.perPage +
            "&cusip=" +
            this.searchValue.trim() +
            "&status=ACTIVE"+
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder+
            "&type=OFFER",
            auth

        )
        .then(result => {
          //console.log(result);
          this.totalRows = result.data.pageInfo.totalElements;
          result.data.content.forEach(function(cusip) {
           cusip.isActive = false;
          });
           this.cusips = result.data.content;
           this.loading = false;
        })
        .catch(e => {
          console.log("Error", e);
          //self.loading = false;
        });
    },
    openAddNewOfferModal(selectedCusip){
        if(selectedCusip){
            this.offerCusip = {...selectedCusip};  
        }else{
            this.offerCusip = {};
        }
        this.addNewOfferModalOpen = !this.addNewOfferModalOpen;
    }
   
  },
  mounted() {
      this.getCusipList();

  }
};
</script>